module.exports = __webpack_public_path__ + "static/home_section2_icon3-db09690eda2c2d4d9234545f50bde2e4.png";